import { LayoutDashboard, Zap, PieChart, BarChart3 } from 'lucide-react';
import ExperienceSwitchPrompt from 'src/newSrc/components/ExperienceSwitchPrompt';
import { NEW_UI_HOME_ROUTE } from 'Constants/commonConstants';
import dashboardImage from 'src/newSrc/assets/svg/PageImages/image1.png';
import rfqScreenImage from 'src/newSrc/assets/svg/PageImages/image2.png';
import bidDetailsImage from 'src/newSrc/assets/svg/PageImages/image3.png';
import reportsImage from 'src/newSrc/assets/svg/PageImages/image4.png';

const SLIDES = [
  {
    title: 'Dashboard',
    image: dashboardImage,
    icon: LayoutDashboard,
    heading: 'Responsive Dashboard',
    description:
      'Optimized for desktops, laptops, tablets, and different screen resolutions.',
  },
  {
    title: 'RFQ Screen',
    image: rfqScreenImage,
    icon: Zap,
    heading: 'Faster RFQ Creation',
    description:
      'Cleaner workflow with improved layouts and quicker access to actions.',
  },
  {
    title: 'Bid Details',
    image: bidDetailsImage,
    icon: PieChart,
    heading: 'Better Bid Insights',
    description:
      'Modern cards, improved readability, and easier navigation across bid information.',
  },
  {
    title: 'Reports',
    image: reportsImage,
    icon: BarChart3,
    heading: 'Enhanced Reporting',
    description:
      'Redesigned reports with a cleaner interface and better organization.',
  },
];

const HIGHLIGHTS = [
  'Fully Responsive',
  'Modern UI',
  'Better Performance',
  'Improved Navigation',
];

// Rendered inside the legacy navbar (src/containers/Navbar), which uses the
// flat theme-color pill styling from src/styles/stylekit — not Tailwind —
// so the trigger is overridden to match that navbar instead of the newSrc
// glass-pill default.
const TryNewUI = () => (
  <ExperienceSwitchPrompt
    triggerLabel='Try New UI'
    title='Discover the New Contracting Experience'
    subtitle='A faster, cleaner, and more responsive interface designed to improve your daily workflow.'
    slides={SLIDES}
    carouselAriaLabel='New experience screenshot previews'
    highlights={HIGHLIGHTS}
    targetRoute={NEW_UI_HOME_ROUTE}
    primaryLabel='Go to New Experience'
    secondaryLabel='Stay Here'
    triggerClassName='flex flex-middle mr-25 ht-36 pl-15 pr-15 br-20 border-theme theme-color bg-theme-light fs-14 fSemibold curP'
    triggerStyle={{}}
    triggerIconClassName='wt-16 ht-16 mr-5'
  />
);

export default TryNewUI;
